import { i18nManager } from '@/utils/i18n';

export default {
  data() {
    return {
      // 组件内部的语言状态
      componentLanguage: this.$store.state.currentLanguage || 'zh-TW'
    };
  },
  
  computed: {
    // 获取当前语言
    currentLang() {
      return this.$store.state.currentLanguage;
    },
    
    // 获取当前语言的文本
    $t() {
      return (category, key) => {
        // 添加对 currentLang 的依赖，确保语言切换时重新计算
        const lang = this.currentLang || localStorage.getItem('language') || 'zh-TW';
        // 使用 i18nManager 获取文本
        const result = this.$i18n.getText(category, key);
        // 如果找不到对应的文本，返回key本身
        return result === key ? key : result;
      };
    }
  },
  
  methods: {
    // 切换语言的方法
    switchLanguage(language) {
      this.$store.commit('SET_LANGUAGE', language);
      this.componentLanguage = language;
      
      // 强制更新组件
      this.$forceUpdate();
      
      // 触发全局事件
      this.$root.$emit('language-changed', language);
      
      // 确保 i18nManager 也更新
      this.$i18n.setLanguage(language);
      
      // 更新Element UI的pagination组件语言
      if (this.$updateElementUILocale) {
        this.$updateElementUILocale(language);
      }
    },
    
    // 获取文本的便捷方法
    getText(category, key) {
      return this.$i18n.getText(category, key);
    },
    
    // 递归强制更新所有子组件
    forceUpdateAllChildren() {
      if (this.$children && this.$children.length > 0) {
        this.$children.forEach(child => {
          if (child.$forceUpdate) {
            child.$forceUpdate();
            // 递归更新子组件的子组件
            if (child.forceUpdateAllChildren) {
              child.forceUpdateAllChildren();
            }
          }
        });
      }
    }
  },
  
  mounted() {
    // 监听语言变化事件
    this.$root.$on('language-changed', (language) => {
      this.componentLanguage = language;
      // 强制更新组件，确保计算属性重新计算
      this.$forceUpdate();
      
      // 递归更新所有子组件
      this.forceUpdateAllChildren();
      
      // 更新Element UI的pagination组件语言
      if (this.$updateElementUILocale) {
        this.$updateElementUILocale(language);
      }
    });
    
    // 监听Element UI locale更新事件
    this.$root.$on('element-ui-locale-updated', (language) => {
      // 强制更新当前组件
      this.$forceUpdate();
      
      // 递归更新所有子组件
      this.forceUpdateAllChildren();
    });
    
    // 初始化时设置Element UI的pagination语言
    if (this.$updateElementUILocale) {
      this.$updateElementUILocale(this.currentLang);
    }
  },
  
  beforeDestroy() {
    // 清理事件监听
    this.$root.$off('language-changed');
    this.$root.$off('element-ui-locale-updated');
  }
};



// WEBPACK FOOTER //
// ./src/mixins/i18nMixin.js